// @flow
import React from 'react';
import PropTypes from 'prop-types';
import CustomModal from '../../../../../elements/CustomModal/CustomModal';
import {makeStyles, Typography} from '@material-ui/core';
import {colors} from '../../../../../assets/styles/colors';

import type {Theme} from '@material-ui/core';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';
type Props = {
  open: boolean,
  handleClose: () => void,
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 320,
    padding: theme.spacing(3, 2, 2, 2),
  },
  title: {
    color: colors.grey900,
    fontWeight: 600,
    fontSize: 18,
    textAlign: 'center',
  },
  subtitle: {
    color: colors.grey900,
    fontWeight: 600,
    fontSize: 14,
    textAlign: 'center',
    margin: theme.spacing(2, 0),
  },
  contactInfo: {
    background: colors.grey200,
    borderRadius: 12,
    padding: theme.spacing(1.5),
  },
  actionsWrap: {
    width: '100%',
    margin: theme.spacing(2, 0),
    display: 'flex',
    gap: '16px',
  },
  text: {
    fontSize: 14,
    color: colors.grey900,
    textAlign: 'center',
  },
}));
export default function MergeContactDetailsModal(props: Props) {
  const {open, handleClose} = props;
  const classes = useStyles();
  return (
    <CustomModal open={open} handleCloseModal={handleClose}>
      <div className={classes.root}>
        <Typography className={classes.title}>
          Hemos encontrado una conversación de WhatsApp con este número
        </Typography>
        <Typography className={classes.subtitle}>
          ¿Desea sincronizarla con este contacto?
        </Typography>

        <div className={classes.contactInfo}>
          <div>
            <Typography className={classes.text}>
              Nombre: asdasd asdasdasd
            </Typography>
            <Typography className={classes.text}>
              Número: 51 994888475
            </Typography>
          </div>
        </div>

        <div className={classes.actionsWrap}>
          <CustomButton fullWidth variant="outlined">
            No
          </CustomButton>
          <CustomButton fullWidth variant="contained">
            Sincronizar
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
}

MergeContactDetailsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
